<mat-sidenav-container class="container" [style.top.px]="dockedNavBar ? 64 : 0">
  <mat-sidenav #sidenav fixedInViewport="true" mode="over">
    <mat-list>
      <mat-list-item *ngIf="keycloak.getKeycloakInstance().hasResourceRole('administrator', 'recordings')">
        <a mat-button [routerLink]="['/scheduler']" [queryParams]="{}" queryParamsHandling=""
          [routerLinkActive]="['active']" (click)="sidenav.close()">
          <mat-icon>av_timer</mat-icon>
          Scheduler
        </a>
      </mat-list-item>
      <mat-list-item *ngIf="keycloak.getKeycloakInstance().hasResourceRole('administrator', 'recordings')">
        <a mat-button [routerLink]="['/group-management']" [queryParams]="{}" queryParamsHandling=""
          [routerLinkActive]="['active']" (click)="sidenav.close()">
          <mat-icon>group</mat-icon>
          <ng-template [ngIf]="keycloak.getKeycloakInstance().hasResourceRole('manager', 'recordings')"
            [ngIfElse]="groupViewCategoryName">
            Group management
          </ng-template>
          <ng-template #groupViewCategoryName>My group</ng-template>
        </a>
      </mat-list-item>
      <mat-list-item *ngIf="keycloak.getKeycloakInstance().hasResourceRole('user', 'recordings')">
        <a mat-button [routerLink]="['/channels']" [queryParams]="{}" queryParamsHandling=""
          [routerLinkActive]="['active']" (click)="sidenav.close()">
          <mat-icon>perm_media</mat-icon>
          Media channels
        </a>
      </mat-list-item>
      <mat-list-item *ngIf="keycloak.getKeycloakInstance().hasResourceRole('administrator', 'recordings')">
        <a mat-button [routerLink]="['/fragments']" [queryParams]="{}" queryParamsHandling=""
          [routerLinkActive]="['active']" (click)="sidenav.close()">
          <mat-icon>broken_image</mat-icon>
          Recorded fragments with problems
        </a>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item *ngIf="keycloak.getKeycloakInstance().hasResourceRole('query-users', 'realm-management')">
        <a mat-button
          href="{{ keycloak.getKeycloakInstance().authServerUrl }}/admin/{{keycloak.getKeycloakInstance().realm}}/console">
          <mat-icon>people</mat-icon>
          User management
        </a>
      </mat-list-item>
      <mat-list-item>
        <a mat-button href="{{ keycloak.getKeycloakInstance().createAccountUrl() }}">
          <mat-icon>account_circle</mat-icon>
          Profile
        </a>
      </mat-list-item>
      <mat-list-item>
        <a mat-button (click)="logout()">
          <mat-icon>directions_run</mat-icon>
          Exit
        </a>
      </mat-list-item>
    </mat-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar color="primary" [ngClass]="{'docked': dockedNavBar}">
      <button mat-icon-button matTooltip="Open menu" (click)="sidenav.toggle()">
        <mat-icon>menu</mat-icon>
      </button>
      <button mat-icon-button (click)="dockedNavBar = !dockedNavBar"
        matTooltip="{{ dockedNavBar ? 'Disconnect panel' : 'Attach the panel' }}">
        <mat-icon>{{ dockedNavBar ? 'arrow_upward' : 'vertical_align_top' }}</mat-icon>
      </button>
      <!-- <button mat-icon-button>
      </button> -->
      <app-theme-menu [options]="styleManager.themes" (themeChange)="themeChangeHandler($event)">
      </app-theme-menu>

      <!-- <button mat-button [matMenuTriggerFor]="animals">Animal index</button> -->
      <span class="spacer"></span>
      <ng-template [ngTemplateOutlet]="topBarControls"></ng-template>
      <!-- <ng-template #topBar></ng-template> -->


    </mat-toolbar>
    <router-outlet (activate)="changeTemplate($event)"></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>

<!-- 
<mat-menu #animals="matMenu">
  <button mat-menu-item [matMenuTriggerFor]="vertebrates">Vertebrates</button>
  <button mat-menu-item [matMenuTriggerFor]="invertebrates">Invertebrates</button>
</mat-menu>

<mat-menu #vertebrates="matMenu">
  <button mat-menu-item [matMenuTriggerFor]="fish">Fishes</button>
  <button mat-menu-item [matMenuTriggerFor]="amphibians">Amphibians</button>
  <button mat-menu-item [matMenuTriggerFor]="reptiles">Reptiles</button>
  <button mat-menu-item>Birds</button>
  <button mat-menu-item>Mammals</button>
</mat-menu>

<mat-menu #invertebrates="matMenu">
  <button mat-menu-item>Insects</button>
  <button mat-menu-item>Molluscs</button>
  <button mat-menu-item>Crustaceans</button>
  <button mat-menu-item>Corals</button>
  <button mat-menu-item>Arachnids</button>
  <button mat-menu-item>Velvet worms</button>
  <button mat-menu-item>Horseshoe crabs</button>
</mat-menu>

<mat-menu #fish="matMenu">
  <button mat-menu-item>Baikal oilfish</button>
  <button mat-menu-item>Bala shark</button>
  <button mat-menu-item>Ballan wrasse</button>
  <button mat-menu-item>Bamboo shark</button>
  <button mat-menu-item>Banded killifish</button>
</mat-menu>

<mat-menu #amphibians="matMenu">
  <button mat-menu-item>Sonoran desert toad</button>
  <button mat-menu-item>Western toad</button>
  <button mat-menu-item>Arroyo toad</button>
  <button mat-menu-item>Yosemite toad</button>
</mat-menu>

<mat-menu #reptiles="matMenu">
  <button mat-menu-item>Banded Day Gecko</button>
  <button mat-menu-item>Banded Gila Monster</button>
  <button mat-menu-item>Black Tree Monitor</button>
  <button mat-menu-item>Blue Spiny Lizard</button>
  <button mat-menu-item disabled>Velociraptor</button>
</mat-menu> -->